import angular from 'angular';
import subscriptionPreloader from './subscriptionPreloader';

export default angular
  .module('component.subscriptionPreloader', [])
  .component('subscriptionPreloader', subscriptionPreloader).name;
